import SEO from './SEO';

const AboutSEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NABAZAT AL QALB",
    "description": "A leading medical supplies and healthcare solutions company in Erbil, Iraq with years of experience serving the healthcare industry",
    "url": "https://nabazatalqalb.com/about",
    "logo": "https://nabazatalqalb.com/logo512.png",
    "foundingDate": "2010",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Erbil",
      "addressRegion": "Arbil",
      "addressCountry": "IQ"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["English", "Arabic", "Kurdish"]
    },
    "sameAs": [
      "https://facebook.com/nabazatalqalb",
      "https://twitter.com/nabazatalqalb",
      "https://linkedin.com/company/nabazatalqalb"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Iraq"
    },
    "serviceType": "Medical Supplies and Healthcare Solutions",
    "knowsAbout": [
      "Medical Equipment",
      "Pharmaceuticals",
      "Healthcare Solutions",
      "Medical Device Distribution",
      "Hospital Supplies",
      "Clinical Equipment"
    ]
  };

  return (
    <SEO
      title="About"
      description="Learn about NABAZAT AL QALB's journey as a leading medical supplies company in Erbil, Iraq. Discover our mission, values, and commitment to providing quality healthcare solutions across Iraq."
      keywords="about NABAZAT AL QALB, medical company Erbil, healthcare company Iraq, medical supplies company, our story, company mission, medical equipment suppliers, healthcare solutions provider"
      url="https://nabazatalqalb.com/about"
      structuredData={structuredData}
    />
  );
};

export default AboutSEO; 